(function () {
  var bookingUrl = 'https://calendar.app.google/P7JeaqdMmsxzGMAfA';

  function getFocusableElements(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
        )
      )
      .filter(function (element) {
        return element.offsetParent !== null || element === document.activeElement;
      });
  }

  // Button initialization: wire the global CTA to the booking modal on every page.
  function initBookMeetingModal() {
    var openButton = document.getElementById('BookMeetingButton');
    var modal = document.getElementById('BookMeetingModal');
    var dialog = modal ? modal.querySelector('.book-meeting-modal-dialog') : null;
    var iframe = document.getElementById('BookMeetingFrame');
    var modalBody = iframe ? iframe.closest('.book-meeting-modal-body') : null;
    var closeButtons = modal ? modal.querySelectorAll('[data-book-meeting-close]') : [];
    var lastFocusedElement = null;
    var bodyWasLocked = false;
    var isOpen = false;

    if (!openButton || !modal || !dialog || !iframe) {
      return;
    }

    openButton.setAttribute('aria-expanded', 'false');
    dialog.setAttribute('tabindex', '-1');

    function loadBookingFrame() {
      // Lazy loading of iframe: Google Appointment Schedule is requested only after the first open.
      if (!iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.dataset.src || bookingUrl);
      }
    }

    function hideLoader() {
      if (modalBody) {
        modalBody.classList.add('is-loaded');
      }
    }

    function focusFirstElement() {
      var focusableElements = getFocusableElements(dialog);

      if (focusableElements.length > 0) {
        focusableElements[0].focus();
        return;
      }

      dialog.focus();
    }

    function keepFocusInside(event) {
      if (event.key !== 'Tab') {
        return;
      }

      var focusableElements = getFocusableElements(dialog);

      if (focusableElements.length === 0) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }

      if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    function handleKeydown(event) {
      if (!isOpen) {
        return;
      }

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      keepFocusInside(event);
    }

    function openModal() {
      // Modal logic: expose the dialog, lock the page behind it, and move keyboard focus inside.
      lastFocusedElement = document.activeElement;
      bodyWasLocked = document.body.classList.contains('overflow-hidden');
      isOpen = true;

      if (modalBody && !iframe.getAttribute('src')) {
        modalBody.classList.remove('is-loaded');
      }

      loadBookingFrame();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', handleKeydown);

      window.requestAnimationFrame(focusFirstElement);
    }

    function closeModal() {
      isOpen = false;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', handleKeydown);

      if (!bodyWasLocked) {
        document.body.classList.remove('overflow-hidden');
      }

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      } else {
        openButton.focus();
      }
    }

    openButton.addEventListener('click', openModal);
    iframe.addEventListener('load', hideLoader);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBookMeetingModal);
  } else {
    initBookMeetingModal();
  }
})();
